module.exports = __webpack_public_path__ + "static/media/TripmanagmentActive.d77dcbc6.svg";